import { render, staticRenderFns } from "./image.vue?vue&type=template&id=fc164064&scoped=true"
import script from "./image.ts?vue&type=script&lang=ts&external"
export * from "./image.ts?vue&type=script&lang=ts&external"
import style0 from "./image.vue?vue&type=style&index=0&id=fc164064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc164064",
  null
  
)

export default component.exports